import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const EnrichPageContainer = styled.div`
    height: auto;
    width: 312px;
    border: none;
`;

export const EnrichHeaderTitle = styled.div`
    margin-bottom: 8px;
`;

export const EnrichTrafficShareContainer = styled.div`
    width: 170px;
    margin-left: 20px;
    .swTable-progressBar {
        margin-top: -3px;
        margin-bottom: 5px;
    }
`;
export const CloseIconButton = styled(IconButton)`
    position: absolute;
    right: 12px;
    top: 11px;
`;

export const DownloadExcelContainer = styled.span`
    margin: 0 8px 0 16px;
`;

export const StyledHeaderTitle = styled.div`
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
    padding-bottom: 8px;
`;

export const StyledBoxSubtitle = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[400])};
`;

export const Right = styled(Flex)`
    align-items: center;
    margin-left: 10px;
`;
export const HeaderStyle = styled(Flex)`
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
`;
